import { useSelector } from 'react-redux'
import { accessTokenSelector } from '../selectors'

const useAccessToken = () => useSelector(accessTokenSelector)

export default useAccessToken
